export default "__VITE_ASSET__0ed9f051__$_?nuxt_component=async__"